module.exports = __webpack_public_path__ + "static/media/infoJumbo1.1d19888b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/fehlmann/images/infoJumbo1.jpg
// module id = 483
// module chunks = 0